import React, { useContext, useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import './CustomAppBar.css';
import { EnvironmentContext } from '../../contexts/EnvironmentContext/EnvironmentContext';
import { AppBarLogo } from './AppBarLogo/AppBarLogo';
import { AppBarDropdowns } from './AppBarDropdowns/AppBarDropdowns';
import { AppBarSideDrawer } from './AppBarSideDrawer/AppBarSideDrawer';
import { NAVBAR_MIN_WIDTH, NAVBAR_MIN_HEIGHT } from '../_data/Constants';

type CustomAppBarProps = {
	name: string,
	pageTitle: string,
	a: () => void
}

/**
 * CustomAppBar is the application bar that (currently) uses MaterialUI
 *
 * Last Modified
 * Jaden Stetler
 * July 17, 2019
 */
export const CustomAppBar: React.FC<CustomAppBarProps> = ({ name, pageTitle, a }) => {
	const { windowWidth } = useContext(EnvironmentContext);
	let minimized = windowWidth < NAVBAR_MIN_WIDTH;

	const [lastScrollPos, setLastScrollPos] = useState(window.scrollY);
	const [scrollUp, setScrollUp] = useState(true);
	let ticking: boolean = false;


	const handleScroll = (e: any) => {
		if (!ticking) {
			window.requestAnimationFrame(() => {
				setScrollUp(window.scrollY < lastScrollPos);
				setLastScrollPos(window.scrollY);
			})

			console.log(window.scrollY)

			ticking = true;
		}
	}
	
	document.addEventListener('scroll', handleScroll);

	return <>
		<div className={"appbar"}
			style={{visibility: (scrollUp || window.scrollY <= 85) ? 'visible' : 'hidden',
					opacity: (scrollUp || window.scrollY <= 85) ? 1 : 0}}
			>
			<AppBar className={"mui-appbar"}
				style={{ minHeight: NAVBAR_MIN_HEIGHT,
						backgroundColor: (window.scrollY <= 125) ? ((window.scrollY <= 105) ? 'rgba(201, 195, 229)' 
								: 'rgba(201, 195, 229, 0.85)')
								: 'rgba(218, 207, 239, 0.75)'}}
				color="secondary">
				<Toolbar style={{ minHeight: NAVBAR_MIN_HEIGHT }}>
					<AppBarLogo />
					{!minimized && <AppBarDropdowns name={name} pageTitle={pageTitle} a={a} />}
					{minimized && <AppBarSideDrawer
						name={name}
						pageTitle={pageTitle}
						a={a}
					/>}
				</Toolbar>
			</AppBar>
		</div>
	</>
}